import { useEffect, useRef, useState } from "react";

export default function useResizeObserver() {
	const ref = useRef(null);
	const [size, setSize] = useState({ width: 0, height: 0 });

	useEffect(() => {
		const element = ref.current;
		if (!element) {
			return undefined;
		}
		const resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				const { width, height } = entry.contentRect;
				setSize({ width, height });
			}
		});
		resizeObserver.observe(element);
		return () => {
			resizeObserver.unobserve(element);
			resizeObserver.disconnect();
		};
	}, []);

	return [ref, size];
}
